import { css } from "@emotion/react";
import type { PropsWithChildren } from "react";

import Spacer from "../space/Spacer";
import { WithSpace } from "../space/WithSpace";

export default function LightPageLayout(props: PropsWithChildren) {
    const { children } = props;
    const containerCss = css({
        maxWidth: 600,
        margin: "0 auto",
    });
    return (
        <WithSpace horizontal={4}>
            <Spacer scale={8} />
            <Spacer scale={8} />
            <Spacer scale={8} />
            <div css={containerCss}>{children}</div>
            <Spacer scale={8} />
            <Spacer scale={8} />
            <Spacer scale={8} />
        </WithSpace>
    );
}
